import { create } from "zustand";
import type { JwtClaims } from "./claims";

export type SessionState =
  | { status: "loading"; accessToken: null; claims: null; tenantIds: string[]; roles: string[]; error: null }
  | { status: "signed_out"; accessToken: null; claims: null; tenantIds: string[]; roles: string[]; error: null }
  | { status: "authenticated"; accessToken: string; claims: JwtClaims; tenantIds: string[]; roles: string[]; error: null }
  | { status: "error"; accessToken: null; claims: null; tenantIds: string[]; roles: string[]; error: string };

interface AuthStore {
  sessionState: SessionState;
  getAccessTokenSilently: (() => Promise<string>) | null;
  setSessionState: (state: SessionState) => void;
  setGetAccessTokenSilently: (fn: () => Promise<string>) => void;
}

export const useAuthStore = create<AuthStore>((set) => ({
  sessionState: {
    status: "loading",
    accessToken: null,
    claims: null,
    tenantIds: [],
    roles: [],
    error: null,
  },
  getAccessTokenSilently: null,
  setSessionState: (state) => set({ sessionState: state }),
  setGetAccessTokenSilently: (fn) => set({ getAccessTokenSilently: fn }),
}));

export function useClaritySession() {
  return useAuthStore((state) => state.sessionState);
}
